import React from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeSimple, Phone, MapPin, Scales } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
             <img src="/assets/img/brand/logo-light.png" alt="Logo" className="h-10" />
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed">
              Trusted by thousands of businesses nationwide, we provide comprehensive intellectual property protection services including trademark registration, copyright filing, patent applications, and entity formation.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold mb-4 text-white uppercase tracking-wider">Trademark</h3>
            <ul className="space-y-2.5">
              <li><Link to="/services/trademark/search-registration" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Search & Registration</Link></li>
              <li><Link to="/services/trademark/clearance" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Clearance Searches</Link></li>
              <li><Link to="/services/trademark/application" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Application Preparation</Link></li>
              <li><Link to="/services/trademark/office-actions" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Office Actions</Link></li>
              <li><Link to="/services/trademark/monitoring" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Monitoring</Link></li>
              <li><Link to="/services/trademark/statement-of-use" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Statement Of Use</Link></li>
              <li><Link to="/services/trademark/ownership-change" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Change of Ownership</Link></li>
              <li><Link to="/services/trademark/portfolio" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Portfolio Management</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold mb-4 text-white uppercase tracking-wider">Copyright</h3>
            <ul className="space-y-2.5">
              <li><Link to="/services/copyright/registration" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Registration</Link></li>
              <li><Link to="/services/copyright/enforcement" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Enforcement</Link></li>
              <li><Link to="/services/copyright/assignments" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Assignments & Licensing</Link></li>
              <li><Link to="/services/copyright/litigation" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Litigation</Link></li>
              <li><Link to="/services/copyright/portfolio" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Portfolio Management</Link></li>
              <li><Link to="/services/copyright/dmca" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">DMCA Services</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold mb-4 text-white uppercase tracking-wider">Patent</h3>
            <ul className="space-y-2.5">
              <li><Link to="/services/patent/searches" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Patent Searches</Link></li>
              <li><Link to="/services/patent/office-actions" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Office Actions</Link></li>
              <li><Link to="/services/patent/applications" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Applications</Link></li>
              <li><Link to="/services/patent/enforcement" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Enforcement</Link></li>
            </ul>

            <h3 className="text-sm font-heading font-bold mb-4 mt-8 text-white uppercase tracking-wider">Formation</h3>
            <ul className="space-y-2.5">
              <li><Link to="/services/company/llc" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">LLC Formation</Link></li>
              <li><Link to="/services/company/c-corp" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">C Corporation</Link></li>
              <li><Link to="/services/company/s-corp" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">S Corporation</Link></li>
              <li><Link to="/services/company/non-profit" className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors">Non-Profit</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold mb-4 text-white uppercase tracking-wider">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#D4AF37] flex-shrink-0 mt-0.5" weight="bold" />
                <span className="text-sm text-slate-400">765 Market St APT 34D<br/>San Francisco, CA 94103</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#D4AF37]" weight="bold" />
                <span className="text-sm text-slate-400">+1 (646) 687-2501</span>
              </div>
              <div className="flex items-center gap-3">
                <EnvelopeSimple className="h-4 w-4 text-[#D4AF37]" weight="bold" />
                <span className="text-sm text-slate-400">info@trademarkthrone.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} Trademark Throne. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-sm text-slate-500 hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
              <span className="text-slate-700">|</span>
              <Link to="/terms" className="text-sm text-slate-500 hover:text-[#D4AF37] transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
